import { Form } from '@/components/forms';
import { EmailInput } from '@/components/forms/email-input/component';
import { FormikProps } from 'formik';
import * as yup from 'yup';

export interface ResetPasswordValues {
	email: string;
}

const validationSchema = yup.object({
	email: yup.string().required('Email is required').email('Invalid email format'),
});

type FormProps = {
	onSubmit: (values: ResetPasswordValues) => void;
	formRef: React.RefObject<FormikProps<ResetPasswordValues>>;
	email?: string;
};

export const ResetPasswordForm = ({ onSubmit, formRef, email }: FormProps) => {
	const initialValues: ResetPasswordValues = {
		email: email?.toLowerCase() ?? '',
	};

	return (
		<Form
			initialValues={initialValues}
			validationSchema={validationSchema}
			onSubmit={onSubmit}
			innerRef={formRef}
		>
			{({ getFieldProps, errors, touched }) => (
				<>
					<EmailInput
						label="Email Address"
						placeholder="john@smith.com"
						{...getFieldProps('email')}
						error={touched.email && errors.email}
						mb="md"
					/>
				</>
			)}
		</Form>
	);
};
